import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-background-text">404</div>
      
      <div className="not-found-content">
        <h1 className="not-found-title">Oops! You've drifted off course.</h1>
        <p className="not-found-subtitle">
          The page you are looking for has been moved or doesn't exist. Let's get you
          back to the main hub.
        </p>
        
        <div className="not-found-actions">
          <Link to="/" className="btn-return-dashboard">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
